import { SceneKey } from './sceneKeys';
import { GameMode } from '../types/GameMode';

/** タイトル画面のボタン設定 */
export interface TitleButtonConfig {
  /** ボタンのラベルテキスト */
  label: string;
  /** 遷移先シーン */
  targetScene: SceneKey;
  /** ゲームモード（モード選択ボタンの場合） */
  mode?: GameMode;
}

/** ゲームタイトルテキスト */
export const TITLE_TEXT = 'Konkaku -Yomi Duel-';

/** タイトル画面のボタン定義（表示順） */
export const TITLE_BUTTONS: TitleButtonConfig[] = [
  {
    label: 'モード選択',
    targetScene: SceneKey.BATTLE_MODE_SELECT,
  },
  {
    label: 'AIキャラ作成',
    targetScene: SceneKey.AI_CHARACTER_EDIT,
  },
  {
    label: '戦績',
    targetScene: SceneKey.BATTLE_STATS,
  },
  {
    label: '実績',
    targetScene: SceneKey.ACHIEVEMENT,
  },
  {
    label: '設定',
    targetScene: SceneKey.SETTINGS,
  },
];
